export interface BatchStatisticsReserveRequest {
  reserveDateFrom: string
  reserveDateTo: string
  reserveTitle: string
  branchCodeFrom: string
  branchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  areaCodeFrom: string
  areaCodeTo: string
  addressCodeForm: string
  addressCodeTo: string
  forwardingRequest: string
  isYearAge: boolean
  requestReserve: string
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  numberOfPeopleEnabled: boolean
  numberOfPeopleActualEnabled: boolean
  isOutputFull: boolean
  reserveMemo: string
  batchType: string
}

export function BatchStatisticsReserveRequestToJSON(
  value: BatchStatisticsReserveRequest
): any {
  return {
    reserve_date_from: value.reserveDateFrom,
    reserve_date_to: value.reserveDateTo,
    reserve_title: value.reserveTitle,
    branch_code_from: value.branchCodeFrom,
    branch_code_to: value.branchCodeTo,
    place_code_from: value.placeCodeFrom,
    place_code_to: value.placeCodeTo,
    area_code_from: value.areaCodeFrom,
    area_code_to: value.areaCodeTo,
    address_code_from: value.addressCodeForm,
    address_code_to: value.addressCodeTo,
    forwarding_request: value.forwardingRequest,
    is_year_age: value.isYearAge,
    request_reserve: value.requestReserve,
    x_item: value.xItem,
    y_item1: value.yItem1,
    y_check1: value.yCheck1,
    y_item2: value.yItem2,
    y_check2: value.yCheck2,
    y_item3: value.yItem3,
    y_check3: value.yCheck3,
    y_item4: value.yItem4,
    y_check4: value.yCheck4,
    number_enabled: value.numberEnabled,
    number_of_people_enabled: value.numberOfPeopleEnabled,
    number_of_people_actual_enabled: value.numberOfPeopleActualEnabled,
    is_output_full: value.isOutputFull,
    reserve_memo: value.reserveMemo,
    batch_type: value.batchType
  }
}
